import { UserInfoService } from './userInfo';
import { GeneralService } from './general';
import { HomeService } from './home/br';
import { RepaymentService } from './repayment/br';
import { PercentageService } from './percentage/br';
import { UpcomingService } from './upcoming/br';
import { TransactionService } from './transaction/br';
import { AdvanceService } from './advance/br';
import { OrderService } from './order/br';

export default {
  userInfo: new UserInfoService(),
  general: new GeneralService(),
  home: new HomeService(),
  repayment: new RepaymentService(),
  transaction: new TransactionService(),
  advance: new AdvanceService(),
  order: new OrderService(),
  percentage: new PercentageService(),
  upcomingStore: new UpcomingService(),
};
